jQuery(document).ready(function($) {
    var ref= document.referrer;
    var contains = "scatecsolar.com";
    if (ref.indexOf(contains) > -1) {
        $(".report-back").on('click', function(e) {
            e.preventDefault();
            window.history.back();
        })
    }
})